export const FETCH_GIFTCARDS_REQUEST = "FETCH_GIFTCARDS_REQUEST";
export const FETCH_GIFTCARDS_SUCCESS = "FETCH_GIFTCARDS_SUCCESS";
export const FETCH_GIFTCARDS_FAILURE = "FETCH_GIFTCARDS_FAILURE";
